import clsx from "clsx";
import React from "react";
import { Icon } from "../Icon";
import styles from "./Accordion.module.css";
import { AccordionProps } from "./Accordion.types";

export const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  isOpen = false,
  id,
  onChange,
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(isOpen);

  React.useEffect(() => {
    setExpanded(isOpen);
  }, [isOpen]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onToggle();
    }
  };

  const accordionHeaderId = `acc-header-${id}`;
  const accordionContentId = `acc-content-${id}`;

  const onToggle = () => {
    if (onChange) {
      onChange();
    } else {
      setExpanded(!expanded);
    }
  };

  return (
    <div className={styles.accordionContainer}>
      <button
        aria-expanded={expanded}
        className={styles.accordionHeaderContainer}
        id={accordionHeaderId}
        aria-controls={accordionContentId}
        onClick={onToggle}
        onKeyDown={handleKeyPress}
      >
        <h3 className={styles.accordionHeader}>{title}</h3>
        <Icon
          className={clsx(
            styles.accordionHeaderIcon,
            expanded && styles.expanded,
          )}
          name="chevron-down"
        />
      </button>
      <div
        id={accordionContentId}
        aria-labelledby={accordionHeaderId}
        role="region"
        className={clsx(
          styles.accordionContentContainer,
          expanded && styles.expanded,
        )}
      >
        <div className={styles.accordionContent}>{content}</div>
      </div>
    </div>
  );
};
